import Hydrant from '../hydrant/index.js';

document.addEventListener('DOMContentLoaded', () => {

  window.hydrant = new Hydrant();
})
